/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryPersonViewModelPaginatedResponse } from "../types/MyLibraryPersonViewModelPaginatedResponse.ts";
import { myLibraryPersonViewModelSchema } from "./myLibraryPersonViewModelSchema.ts";

export const myLibraryPersonViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => myLibraryPersonViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<MyLibraryPersonViewModelPaginatedResponse>;
